import { Box, Stack, styled, Typography } from '@mui/material';

import { DateInfo } from 'Common/DateInfo';
import { TimeInfo } from 'Common/TimeInfo';
import { TimezoneWarning } from 'Common/TimezoneWarning/TimezoneWarning';
import { Colors } from 'Themes/colors';
import { useSelectUserTimezone } from 'User/data';

import type { ICourseDates } from '@libs/models';
import { PlayArrowIcon } from '@libs/shared/ui/icons';
import { Spacing } from '@themes/spacing';

const StyledPlayArrowIcon = styled(PlayArrowIcon)`
  color: ${Colors.darkGrey};
  margin-left: -0.5rem !important;
`;

const DatesContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.xsmall};
`;

const DateRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`;

type Props = {
  dates: ICourseDates[] | undefined;
  courseTimezone?: string;
  showTimezoneWarning?: boolean;
};

export const CourseDatesDisplay = ({
  dates,
  courseTimezone,
  showTimezoneWarning = true
}: Readonly<Props>) => {
  const userTimezone = useSelectUserTimezone();
  const displayTimezone = userTimezone ?? courseTimezone ?? 'UTC';

  const dateComponents = dates?.map((date, index) => {
    const startDate = date.startDate;
    const endDate = date.endDate;

    return (
      <DateRow key={`${date.startDate}-${date.endDate}-${index}`}>
        <Stack direction="row" spacing={1} alignItems="center">
          <StyledPlayArrowIcon />
          <Typography>
            {startDate ? (
              <>
                <DateInfo date={startDate} timezone={displayTimezone} />{' '}
                <TimeInfo date={startDate} timezone={displayTimezone} />
              </>
            ) : (
              ''
            )}{' '}
            -{' '}
            {endDate ? (
              <>
                <DateInfo date={endDate} timezone={displayTimezone} />{' '}
                <TimeInfo date={endDate} timezone={displayTimezone} />
              </>
            ) : (
              ''
            )}
          </Typography>
        </Stack>
        {showTimezoneWarning && <TimezoneWarning userTimezone={userTimezone} variant="tooltip" />}
      </DateRow>
    );
  });

  return dates ? (
    <DatesContainer>
      <Stack gap={1}>{dateComponents}</Stack>
    </DatesContainer>
  ) : null;
};
